import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from "moment";
import { connect } from 'react-redux';
import * as reportsDashboardActions from '../../../../../actions/launchAction/reportsDashboardActions';
let CurrentDate = moment().format('YYYY-MM-DD');
class StorageCount extends Component{
    componentWillMount(){ 
        let {dispatch} =this.props;
        dispatch(reportsDashboardActions.getStorageCount(CurrentDate, CurrentDate))
    }
    render(){
        return(
            <>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> 
                    <div class="card card-stats" style={{minHeight: '185px'}}>
                        <div class="card-header" data-background-color="green"><img width="40" src={require('../../../../../assets/img/icon_box.png')}/></div>
                        <div class="card-content">
                            <p class="category" style={{minHeight: '35px', fontSize: '0.85em'}}>Storage Count</p>
                            <p class="category" style={{fontSize: '11px', paddingTop: '11px', color: 'rgb(115, 135, 156)', fontWeight: 'bold'}}>{'till '+CurrentDate }</p>
                            <span class="title" style={{fontSize: '25px'}}>{this.props.reportDashboard.storageCount.vehicleStorageCount || 0}</span>
                        </div>
                        <div class="card-footer text-right">
                        <div class="stats">
                            <Link class="btn btn-sm btn-primary" to={`/reportschart/storagecountchart`} style={{marginBottom: '0px', marginRight: '0px', padding: '2px 6px'}}>
                            <i class="fa fa-bar-chart"></i>
                            </Link>
                        </div>
                        </div>                       
                    </div> 
                    </div>
            </>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        authInfo: state.authInfo,
        reportDashboard:state.reportDashboard
        //refNotify:state.refNotify
    }
};

export default connect(mapStateToProps)(StorageCount);